import { getSubstrings } from 'utils/functions';

const Station = {
  searchStrings: (station) =>
    station.uic && station.name && station.shortCode ? [station.shortCode.toLowerCase(), ...getSubstrings(station.name)] : []
};

export default Station;
